import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillEye,AiFillDelete } from "react-icons/ai";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { useContext } from "react";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import { BsArrowUpShort } from "react-icons/bs";

const SubscriptionList = ({
  subscriptionList,
  page,
  allSubscription,
  handleEdit,
  handleView,
  handelDelete,
  sort,
  setSort,
  manager,
}) => {
  const notification = useToastContext();
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.subscriptionStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allSubscription();
      }
    } catch (error) {
      console.log("error in get all subscription list==>>>>", error.message);
    }
  };
  const statusChangeConfirmation = (item, e) => {
    helper.alertFunction(
      `Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${
        item.name
      }'?`,
      item,
      handelStatusChange
    );
  };

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto relative rounded-lg border">
          <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-3 px-6">
                  Sr no.
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("SUBSCRIPTION_ID")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("SUBSCRIPTION_NAME")}
                </th>

                <th className="py-3 px-6" scope="col">
                  {t("DURATION")} (In days)
                </th>
                <th scope="col" className="px-6 py-3">
                  {t("AMOUNT")}
                </th>
                <th className="py-3 px-6" scope="col">
                  {t("DESCRIPTION")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("NUMBER_OF_EMPLOYEE")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("NUMBER_OF_HR")}
                </th>
                <th scope="col" className="py-3 px-6">
                  {t("NUMBER_OF_ACCOUNTANT")}
                </th>
                <th
                  scope="col"
                  className="px-6 cursor-pointer py-3 "
                  onClick={() => {
                    const newSortType =
                      sort.sortType === "asc" ? "desc" : "asc";
                    setSort({
                      sortBy: "createdAt",
                      sortType: newSortType,
                    });
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("CREATED_DATE")}</span>
                    <span>
                      {sort.sortBy === "createdAt" && (
                        <BsArrowUpShort
                          className={`w-4 h-4 ${
                            sort.sortType === "asc" ? "" : "rotate-180"
                          }`}
                        />
                      )}
                    </span>
                  </div>
                </th>

                <th scope="col" className="text-center py-3 px-6 ">
                  {t("O_STATUS")}
                </th>

                <th scope="col" className="px-6 text-center py-3 ">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>

            <tbody>
              {subscriptionList &&
                subscriptionList.map((item, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                    >
                      <th
                        scope="row"
                        className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white"
                      >
                        {i + 1 + 10 * (page - 1)}
                      </th>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {item?._id}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {item?.name}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {item?.duration}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        ${item?.amount}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        <div className="max-text-scroll overflow-auto max-h-[100px]">
                          {item?.description.join(", ")}
                        </div>
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {item?.noOfEmployee}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {item?.noOfHR}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900">
                        {item?.noOfAccountant}
                      </td>
                      <td className="py-4 px-6 border-r text-gray-900 text-right">
                        {dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")}{" "}
                      </td>

                      <td className="py-4 px-6 border-r text-gray-900 text-center">
                        <label
                          className="inline-flex relative items-center cursor-pointer"
                          title={`${
                            item?.status === "active" ? "Active" : "Inactive"
                          }`}
                        >
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={item?.status === "active"}
                            onChange={(e) => statusChangeConfirmation(item, e)}
                          />
                          <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                        </label>
                      </td>

                      <td className="py-4 px-6 border-r text-gray-900">
                        <div className="">
                          <ul className="flex justify-center">
                            {(manager?.edit || user?.role === "admin") && (
                              <li
                                onClick={() => handleEdit(item)}
                                className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                              >
                                <a
                                  title="Edit subscription"
                                  className="hover:text-blue-700 transition duration-150 ease-in-out"
                                  data-bs-toggle="tooltip"
                                >
                                  {" "}
                                  <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                                </a>
                              </li>
                            )}
                            {(manager?.view || user?.role === "admin") && (
                              <li
                                onClick={() => handleView(item)}
                                className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                              >
                                <a title="View subscription">
                                  {" "}
                                  <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                                </a>
                              </li>
                            )}

                            {(manager?.view || user?.role === "admin") && (
                              <li
                                onClick={(e) =>
                                  helper.alertFunction(
                                    `Are you sure want to delete '${item.name}'?`,
                                    item,
                                    handelDelete,
                                    true
                                  )
                                }
                                className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                              >
                                <button title={t("DELETE_SUBSCRIPTION")}>
                                  {" "}
                                  <AiFillDelete className="w-5 h-5 text-red-600" />{" "}
                                </button>
                              </li>
                            )}
                          </ul>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              {isEmpty(subscriptionList) ? (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={12}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionList;
